import { render } from "./SummaryCardSalesItem.vue?vue&type=template&id=5a59b20c&scoped=true"
import script from "./SummaryCardSalesItem.vue?vue&type=script&lang=js"
export * from "./SummaryCardSalesItem.vue?vue&type=script&lang=js"

import "./SummaryCardSalesItem.vue?vue&type=style&index=0&id=5a59b20c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a59b20c"]])

export default __exports__